var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-image",style:({
    height: _vm.size + 'px',
    width: _vm.size + 'px',
    'line-height': _vm.size + 'px',
    'font-size': _vm.size / 3 + 'px'
  })},[_vm._v("\n  "+_vm._s(_vm.initials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }